import {
  SidePanelDS,
  Spacer,
  TableTagLinkyConsentStatus,
  TextCapitalized,
  dateFormatterDayMonthYear,
} from "@qivia/ui";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { LinkyConsentApi } from "../../linkyConsentsAPI";
import "../../../../../i18n/i18n";

export const DriverDetails = (props: { driver: LinkyConsentApi }) => {
  const { t } = useTranslation();
  const { driver } = props;

  return (
    <>
      <SectionTitle>
        <TextCapitalized>
          {t("linky_consents.sidePanel.detail.title")}
        </TextCapitalized>
      </SectionTitle>
      <Spacer y={2} />
      <SidePanelDS.SectionRow
        label={
          <SectionRowLabel>
            <TextCapitalized>
              {t("linky_consents.sidePanel.detail.vehicleEnergyType")}
            </TextCapitalized>
          </SectionRowLabel>
        }
        value={"-"}
      />
      <Spacer y={2} />
      <SidePanelDS.SectionRow
        label={
          <SectionRowLabel>
            <TextCapitalized>
              {t("linky_consents.sidePanel.detail.consentStatus")}
            </TextCapitalized>
          </SectionRowLabel>
        }
        value={<TableTagLinkyConsentStatus status={driver.consentStatus} />}
      />
      <Spacer y={2} />
      <SidePanelDS.SectionRow
        label={
          <SectionRowLabel>
            <TextCapitalized>
              {t("linky_consents.sidePanel.detail.connectionDate")}
            </TextCapitalized>
          </SectionRowLabel>
        }
        value={
          driver.connectionDate
            ? dateFormatterDayMonthYear(new Date(driver.connectionDate))
            : "-"
        }
      />
    </>
  );
};

const SectionTitle = styled.div`
  ${typographies["Body/L"]}
  color: ${colors["colors/text/darkGrey"]}
`;

const SectionRowLabel = styled.div`
  ${typographies["Body/L"]}
  color: ${colors["colors/text/black"]}
`;
